export const SUBDOMAINS = {
  drive: 'drive',
  my: 'my'
};

export const featureFlags = {
  SCAVENGER_HUNT_DRIVING_SCHOOL: process.env.NEXT_PUBLIC_SCAVENGER_HUNT_DRIVING_SCHOOL === 'true',
  SHARE_API_KEYS: process.env.NEXT_PUBLIC_SHARE_API_KEYS === 'true',
}
